import "./whatsApp.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

const WhatsApp = () =>{
    return(
        <div className="sticky">
        <div className="btn"><a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP btnNav"><span><FontAwesomeIcon icon={faPhoneAlt}/></span><span className="wText">WhatsApp Us</span></button></a> </div>
        </div> 
    )
}
export default WhatsApp